// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleBody_root__17rER","fullDivider":"ArticleBody_fullDivider__2uUlw","partialDivider":"ArticleBody_partialDivider__1edRp"};